<article class="noticia">
  <app-skeleton-image [size]="idStart === 0 ? 980 : 320" [aspectRatio]="'97 / 55'" [src]="noticia?.urlGenerica" [lazy]="idStart > 3" loading="lazy"></app-skeleton-image>
  <div class="contenedor-info-noticia">
    <div class="header-article">
      <a class="header-link" [routerLink]="['/noticias', noticia?.idVideo, noticia.tituloSeo | kebabCase]" [innerHTML]="noticia.tituloVideo" [attr.aria-label]="noticia.tituloVideo"></a>
    </div>
    <p class="description-article" [innerHTML]="noticia.entradillaVideo" [routerLink]="['/noticias', noticia?.idVideo, noticia?.tituloSeo | kebabCase]"></p>
    <div class="footer-article">
      <a class="canal-noticia" style="position: relative" [routerLink]="['/seccion', noticia?.idSubcanal, noticia?.nombreSubcanal | kebabCase]">{{ noticia?.nombreSubcanal }}</a>
      {{ noticia.tags }}
      @for (tag of noticia.tags | slice: 0 : 2; track tag) {
        <span class="tag-noticia"
          ><a [routerLink]="['/tag', $any(tag) | kebabCase]">{{ tag }}</a>
          <span class="separador"> | </span>
        </span>
      }
      {{ formatDate(noticia.fecha) | date: "dd/MM/yyyy HH:mm" }}
    </div>
  </div>
</article>
